// extracted by css-extract-rspack-plugin
export default {"cls1":"EmailRegistrationPage-cls1_JKF","cls2":"EmailRegistrationPage-cls2_qCD EmailRegistrationPage-cls1_JKF"};